module.exports = __webpack_public_path__ + "img/20160410_1624.a011b3b4.jpg";